// /frontend/src/forms/jobFormFields.js

export const jobFormFields = [
  {
    name: 'title',
    label: 'Titolo dell\'Annuncio',
    type: 'text',
    required: true,
    gridSpan: 12,
    helperText: 'Es. "Giardiniere Esperto per Ville Private"'
  },
  {
    name: 'location',
    label: 'Luogo di Lavoro',
    type: 'text',
    required: true,
    gridSpan: 6,
    helperText: 'Es. "Como e provincia"'
  },
  {
    name: 'province',
    label: 'Provincia',
    type: 'select',
    required: false,
    gridSpan: 6,
    options: [
      { value: 'CO', label: 'Como' },
      { value: 'MI', label: 'Milano' },
      { value: 'BG', label: 'Bergamo' },
      { value: 'BS', label: 'Brescia' },
      { value: 'CR', label: 'Cremona' },
      { value: 'LC', label: 'Lecco' },
      { value: 'LO', label: 'Lodi' },
      { value: 'MN', label: 'Mantova' },
      { value: 'MB', label: 'Monza e Brianza' },
      { value: 'PV', label: 'Pavia' },
      { value: 'SO', label: 'Sondrio' },
      { value: 'VA', label: 'Varese' }
    ]
  },
  {
    name: 'type',
    label: 'Tipo di Contratto',
    type: 'select',
    required: true,
    gridSpan: 6,
    options: [
      { value: 'stage', label: 'Stage' },
      { value: 'full_time', label: 'Tempo Pieno' },
      { value: 'part_time', label: 'Tempo Parziale' },
      { value: 'freelance', label: 'Freelance' }
    ],
    helperText: 'Seleziona il tipo di contratto'
  },
  {
    name: 'description',
    label: 'Descrizione Completa della Posizione',
    type: 'textarea',
    required: true,
    gridSpan: 12,
  },
  {
    name: 'requirements',
    label: 'Requisiti Richiesti',
    type: 'textarea',
    required: true,
    gridSpan: 12,
    helperText: 'Elenca le competenze, esperienze o qualifiche necessarie.'
  },
  {
    name: 'salary',
    label: 'Retribuzione (Opzionale)',
    type: 'text',
    required: false,
    gridSpan: 12,
    helperText: 'Es. "RAL 25.000€", "Da definire in base all\'esperienza"'
  },
  {
    name: 'categories',
    label: 'Aree di Competenza',
    type: 'autocomplete',
    required: true,
    gridSpan: 12,
    helperText: 'Seleziona una o più categorie per questo annuncio.'
  },
];